<template>
  <section class="question question-old">
    <div class="container">
      <div class="text-center">
        <h2>Întrebări frecvente</h2>
        <div class="questions--container">
          <div class="row align-items-center justify-content-between">
            <div class="col-3 questions--container-img">
              <img src="../../assets/images/image-secretele-laptelui/olivia.png">
            </div>
            <div class="col-8 questions--container-info">
              <p style="color: #707070"><span class="consultant-name">Olivia Forgiarini</span> <br> Expert AptaNutricia și educator perinatal certificat
                <br> SAMAS răspunde
                celor mai frecvente întrebări despre laptele matern.</p>
            </div>
            <div class="col-8 questions--container-info-mobile">
              <p style="color: #707070"><span class="consultant-name">Olivia Forgiarini</span> <br> Expert AptaNutricia și educator perinatal certificat
              </p>
            </div>
            <div class="col-12 p-mobile">
              <p class="p-blue">Olivia răspunde celor mai frecvente întrebări despre laptele matern.</p>

            </div>
          </div>
        </div>

      </div>
      <div class="services-left accordion" id="servicesAccordion">
        <div class="col-lg-8 col-md-12 col-feature  row-eq-height mx-auto">
          <div class="feature row-eq-height mb-4 ripple riple-service collapsed" feature-border="1"
               data-toggle="collapse" href="#collapseServicesOne" role="button" aria-expanded="false"
               aria-controls="collapseServicesOne">
            <div class="feature-content ">
              <div>
                <h5 class="feature-mobile-title">GUST</h5>
                <p>Copilul meu refuză laptele de la sân, oare am mâncat ceva ce nu îi place?</p>
              </div>
              <div class="collapse" id="collapseServicesOne" data-parrent="#servicesAccordion" style="">
                <p class="gray">În perioada alăptării poți mânca orice, fără excese și din toate grupele
                  alimentare. Totuși, evită alimentele foarte condimentate și nu mânca excesiv ceva
                  anume.
                  Dacă respecți o dietă echilibrată, gustul laptelui matern nu se modifică.
                </p>
              </div>
            </div>
            <i class="services-arrow"></i>
          </div>
        </div>
        <div class="col-lg-8 col-md-12 col-feature  row-eq-height mx-auto">
          <div class="feature row-eq-height mb-4 ripple collapsed" feature-border="2" data-toggle="collapse"
               href="#collapseServicesTwo" role="button" aria-expanded="false"
               aria-controls="collapseServicesTwo">
            <div class="feature-content ">
              <div>
                <h5 class="feature-mobile-title">CONSISTENȚĂ</h5>
                <p>Am un bebe cu vârsta mai mare de 1 an, iar în grupurile de mămici se vorbește că
                  ar trebui să îl înțarc, pentru că laptele nu mai este consistent. Ce să fac? </p>

              </div>
              <div class="collapse" id="collapseServicesTwo" data-parrent="#servicesAccordion" style="">
                <p class="gray">Alăptarea se poate face atât timp cât îți dorești și cât vă face plăcere, ție și
                  lui bebe. La această vârstă alimentația lui bebe este formată din mai multe mese
                  solide decât numărul de mese de lapte. Consistența laptelui matern se modifică în
                  permanență pe durata alăptării. Așadar, cât timp laptele matern nu reprezintă hrana
                  preponderentă și copilul mănâncă echilibrat și diversificat, nu este niciun fel de
                  problemă că primește sân în continuare.
                  Totuși, dacă alăptarea nu mai este posibilă, există varianta substituirii cu formulă
                  de lapte. Discută cu medicul tău care sunt cele mai bune opțiuni pentru tine și
                  copilul tău.
                </p>
              </div>
            </div>
            <i class="services-arrow"></i>
          </div>
        </div>
        <div class="col-lg-8 col-md-12 col-feature row-eq-height mx-auto">
          <div class="feature collapsed row-eq-height mb-4 ripple" feature-border="3" data-toggle="collapse"
               href="#collapseServicesThree" role="button" aria-expanded="false"
               aria-controls="collapseServicesThree">
            <div class="feature-content question-content">
              <div>
                <h5 class="feature-mobile-title">CONSISTENȚĂ </h5>
                <p>Bebe are 2 luni si după ce termină de supt plânge și îi este iar foame. Oare
                  laptele meu este neconsistent? </p>
              </div>
              <div class="collapse" id="collapseServicesThree" data-parrent="#servicesAccordion">
                <p class="gray">Laptele tău este foarte bun! Poate fi vorba doar despre un puseu de creștere.
                  Puseele de creștere apar în jurul vârstei de 3 sau 6 săptămâni și 3 sau 6 luni.
                  Puseele de creștere sunt perioade când bebelușii au nevoie de ceva mai mult lapte,
                  astfel că solicită atenția mamei pentru a suge mai des, pare că nu se satură.
                  Consistența laptelui matern diferă în funcție de etapa suptului. Primul val ține de
                  sete, iar valurile ulterioare conțin grăsimea necesară pentru hrănirea copilului. De
                  aceea este important ca bebe să sugă eficient și suficient. </p>
              </div>
            </div>
            <i class="services-arrow"></i>
          </div>
        </div>
        <div class="col-lg-8 col-md-12 col-feature  row-eq-height mx-auto">
          <div class="feature row-eq-height mb-4 ripple riple-service collapsed" feature-border="1"
               data-toggle="collapse" href="#collapseServicesFour" role="button" aria-expanded="false"
               aria-controls="collapseServicesFour">
            <div class="feature-content question-content">
              <div>
                <h5 class="feature-mobile-title">CULOARE</h5>
                <p>Am observat că laptele meu este de culoare albăstrui, de ce?</p>
              </div>
              <div class="collapse" id="collapseServicesFour" data-parrent="#servicesAccordion" style="">
                <p class="gray">Culoarea laptelui matern diferă în funcție de etapa suptului. La început,
                  colostrul este gălbui, la fel poate fi și laptele. De asemenea, laptele matern poate
                  fi de culoare alb/albăstrui la începutul suptului (în primele 5 minute de muls),
                  abia după 15 minute de muls acesta poate deveni gălbui. </p>
              </div>
            </div>
            <i class="services-arrow"></i>
          </div>
        </div>
        <div class="col-lg-8 col-md-12col-feature  row-eq-height mx-auto">
          <div class="feature row-eq-height mb-4 ripple collapsed" feature-border="2" data-toggle="collapse"
               href="#collapseServicesFive" role="button" aria-expanded="false"
               aria-controls="collapseServicesFive">
            <div class="feature-content question-content">
              <div>
                <h5 class="feature-mobile-title">CANTITATE</h5>
                <p>Cum îmi dau seama că am suficient lapte pentru ca bebe să crească bine? </p>

              </div>
              <div class="collapse" id="collapseServicesFive" data-parrent="#servicesAccordion" style="">
                <p class="gray">Cantitatea de lapte matern produsă de sâni poate să difere în perioada alăptării,
                  în funcție de diverși factori. Dacă bebe are minim 6 urinări în 24 de ore, iar
                  scaunele sunt normale, nu ai motive de îngrijorare. Bebe suge cantitatea necesară de
                  lapte pentru etapa de vârstă în care se află. </p>
              </div>
            </div>
            <i class="services-arrow"></i>
          </div>
        </div>
        <div class="col-lg-8 col-md-12 col-feature row-eq-height mx-auto">
          <div class="feature collapsed row-eq-height mb-4 ripple" feature-border="3" data-toggle="collapse"
               href="#collapseServicesSix" role="button" aria-expanded="false"
               aria-controls="collapseServicesSix">
            <div class="feature-content question-content">
              <div>
                <h5 class="feature-mobile-title">CERCETAREA LAPTELUI MATERN</h5>
                <p>Ce lapte ar trebui să consume copilul meu după ce am încheiat alăptarea? </p>
              </div>
              <div class="collapse" id="collapseServicesSix" data-parrent="#servicesAccordion">
                <p class="gray">Laptele matern este cea mai bună hrană pentru copilul tău. Totuși, dacă ai
                  încheiat alăptarea, trebuie să știi că o bună opțiune este formula de lapte și nu
                  laptele de vacă. Progresul științei în cercetarea laptelui matern este fantastic în
                  ultimii ani. NUTRICIA este singura companie care deține un centru de cercetare
                  dedicat laptelui matern. De peste 40 de ani, la NUTRICIA cercetăm laptele matern
                  împreună cu echipa noastră pasionată de peste 500 de oameni de știință și experți
                  pentru a crea formule de lapte inspirate de laptele matern.</p>
              </div>
            </div>
            <i class="services-arrow"></i>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss">
.question h2 {
  font-size: 40px;
  font-weight: 700;
  color: #17479E;
  text-align: center;
}

.consultant-p {
  color: #707070 !important;
}

.questions--container-info-mobile {
  display: none;
}

.question .questions--container-info p {
  color: #707070 !important;
  font-weight: 500;
}

.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.p-mobile {
  display: none;
}

.feature.collapsed {
  background: #C4E4F9;
}

.services-left .feature {
  padding: 10px 20px;
}

.ripple {
  position: relative;
  z-index: 2;
}

.questions--container {
  max-width: 700px;
  margin: auto;
  text-align: left;
  margin-bottom: 20px;
}

.ripple::after,
.ripple::before {
  position: absolute;
  z-index: -1;
  display: block;
  content: '';
}

.feature h5 {
  margin: 20px 0 0;
  color: #17479E !important;
  font-weight: 700;
  font-size: 16px;
}

.question .consultant-name {
  color: #029FE3;
  font-size: 20px;
  font-weight: 600;
}

.feature p {
  color: #17479E !important;
  font-size: 14px !important;
  font-weight: 400;

}

.ripple,
.ripple::after,
.ripple::before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}

.feature-content {
  width: 95%;
  background: #C4E4F9;
  text-align: left;
}

.feature {
  background: #C4E4F9;
  padding: 0 25px 20px;
  border-radius: 20px;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  z-index: 1;

}

.feature .gray {
  color: #707070 !important;
  margin-top: 10px;
}

.feature.collapsed .feature-arrow,
.feature.collapsed .services-arrow {
  transform: rotate(0deg);
}

.feature .feature-arrow,
.feature .services-arrow {
  transform: rotate(180deg);
}

.feature-arrow,
.services-arrow {
  transition: 0.3s transform linear;
}

.feature-arrow,
.services-arrow {
  display: inline-block;
  height: 32px;
  background-repeat: no-repeat;
  width: 32px;
  position: relative;
}

.services-features .feature .services-arrow {
  background-image: url("../../assets/images/image-secretele-laptelui/arrow-up.svg");
}

.feature .feature-arrow.purple-arrow,
.feature .services-arrow,
.feature.collapsed .services-arrow,
section.high-standard .feature.collapsed:hover .feature-arrow.purple-arrow {
  background-image: url("../../assets/images/image-secretele-laptelui/arrow-down.png");
}


@media screen and (max-width: 992px) {
  .p-mobile {
    display: block;

    .p-blue {
      color: #17479E;
      font-size: 14px;
      text-align: center;
      font-weight: 600;
    }
  }
  .questions--container-info-mobile {
    display: block;
  }
  .questions--container-info {
    display: none;
  }

  .question p {
    text-align: left;
  }
  .question p br {
    display: none;
  }
}

@media screen and (max-width: 526px) {
  .question h2 {
    font-size: 26px;
  }
}


</style>
